import Polyglot from 'node-polyglot';
import Sentry from '../utils/Sentry';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import { loadMomentLocale } from './locale';
import nl from './nl.json';

const LOCALES = ['de', 'en', 'fr', 'nl'] as const;
export type Locale = (typeof LOCALES)[number];
const DEFAULT_LOCALE: Locale = 'en';

type LocaleDefinition = typeof fr;
export type LocaleKey = keyof LocaleDefinition;

function isCorrectLocale(locale?: string): locale is Locale {
  return !!locale && LOCALES.includes(locale);
}

function getShortLocale(locale: string): Locale {
  const shortLocale = locale.toLowerCase().split(/[_-]+/)[0];
  if (isCorrectLocale(shortLocale)) {
    return shortLocale;
  }
  return DEFAULT_LOCALE;
}

const locale = getShortLocale((navigator.languages && navigator.languages[0]) || navigator.language);

loadMomentLocale(locale).catch(() => console.error('could not load locale module'));

const locales: Record<Locale, Record<string, string>> = {
  de,
  en,
  fr,
  nl,
};

const phrases = locales[locale];

const polyglot = new Polyglot({
  locale,
  phrases,
  pluralRules: {
    pluralTypes: {
      treeTypesPlural: (n) => (n <= 1 ? n : 2),
    },
    pluralTypeToLanguages: {
      treeTypesPlural: ['de', 'en', 'fr', 'nl'],
    },
  },
  onMissingKey: (key, _, locale) => {
    console.warn('Missing translation', { key, locale });
    Sentry.getInstance().captureMessage(`Missing translation ${JSON.stringify({ key, locale })}`);
    return key;
  },
});

export const I18n = {
  t: (polyglot.t.bind(polyglot) || (() => '')) as (
    key: LocaleKey,
    options?: number | Polyglot.InterpolationOptions,
  ) => string,
  locale,
};
